import React from "react"

const cleanUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  return url.toLowerCase().replace(/[\s-]+/g, '-');
};

const RoomCategoryLinkList = ({
  roomTypes,
  styles,
  baseUrl = "/interior-ai-room-designer",
  title = "Try Our AI Room Designer",
  description = "Experience the future of interior design with our AI room designer. Upload a photo of your room and get instant design transformations.",
  showDescription = true,
  popularStylesPerRoom = 4
}) => {
  // Get popular styles
  const popularStyles = styles?.slice(0, popularStylesPerRoom) || [];

  const getRoomCombinations = (roomName) => {
    const combinations = [];
    
    // Create combinations for this room with popular styles
    popularStyles.forEach(style => {
      const roomNameStr = typeof roomName === 'string' ? roomName : (roomName?.name || roomName);
      const styleStr = typeof style === 'string' ? style : (style?.name || style);
      
      if (roomNameStr && styleStr) {
        combinations.push({
          url: `${baseUrl}/${cleanUrl(styleStr)}/${cleanUrl(roomNameStr)}`,
          title: `${styleStr} ${roomNameStr}`,
          subtitle: styleStr
        });
      }
    });
    
    return combinations;
  };

  return (
    <section className="bg-[#f7f6f4] py-40 mt-16">
      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
      <div className="container mx-auto px-4 max-w-7xl">
        {/* Title Section */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif font-medium text-gray-900 mb-4">{title}</h2>
          {showDescription && (
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">{description}</p>
          )}
        </div>
        
        {/* Room Types Horizontal Scroll */}
        <div className="relative">
          <div className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory">
            {roomTypes?.slice(0, 12).map((room, roomIndex) => {
              const roomName = typeof room === 'string' ? room : (room?.name || room);
              if (!roomName) return null;
              
              const roomCombinations = getRoomCombinations(roomName);
              
              return (
                <div key={roomIndex} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 min-w-[280px] flex-shrink-0 snap-start">
                  {/* Room Title */}
                  <div className="mb-4">
                    <h3 className="text-xl font-medium text-gray-900 mb-2">{roomName}</h3>
                    <a 
                      href={`${baseUrl}/${cleanUrl(roomName)}`}
                      className="text-sm text-pink-600 hover:text-pink-700 font-medium"
                    >
                      View all {roomName.toLowerCase()} designs →
                    </a>
                  </div>
                  
                  {/* Popular Styles for this room */}
                  <div className="space-y-2">
                    {roomCombinations.slice(0, 3).map((combination, index) => (
                      <a 
                        key={index}
                        href={combination.url}
                        className="block p-3 rounded-lg hover:bg-gray-50 transition-colors group"
                        title={combination.title}
                      >
                        <div className="flex justify-between items-center">
                          <div>
                            <p className="font-medium text-gray-900 group-hover:text-pink-600 transition-colors text-sm">
                              {combination.title}
                            </p>
                          </div>
                          <div className="text-gray-400 group-hover:text-pink-500 transition-colors">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                          </div>
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default RoomCategoryLinkList 